<template>
  <div>
    <v-card-title v-if="!cardOnly">
      <v-row>
        <v-col class="d-flex flex-column align-start ml-2" sm="6" md="6" v-if="!token">
          <v-btn fab dark small elevation="0" class="pa-2 mb-1" @click="previousSlide">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span>Back</span>
        </v-col>
      </v-row>
    </v-card-title>
    <h2 v-if="loading">Loading your virtual card...</h2>
    <p v-if="loading" class="grey--text mt-2">This should only take a few seconds.</p>
    <Robin
      v-if="loading"
      :showText="false"
      :width="140"
      :height="140"
      animation="babyDance"
      :loop="true"
      class="d-flex justify-center"
    />
    <h1 v-if="!loading && !cardOnly">Your Virtual Card</h1>
    <div id="marqeta-script"></div>
    <div id="marqeta-bootstrap-script"></div>
    <Alert
      v-if="loadFailed"
      variant="error"
      :message="loadFailedMessage"
      data-testid="virtual-card-error"
    />
    <v-card
      v-else
      class="mx-auto align-text-left py-2 px-2 virtual-card"
      :elevation="elevation ? 2 : 0"
      :color="on3Card ? 'black' : skinCliqueCard ? '#1B1A30' : 'white'"
      :class="{
        'hidden shrink': loading,
        'my-4': !cardOnly,
        'card-border rounded-xl': !elevation,
        'virtual-card--on3': on3Card,
      }"
    >
      <div
        class="d-flex flex-column px-xs-6"
        :class="{
          'brand--text': !darkCardVariant,
          'white--text': darkCardVariant,
        }"
      >
        <div
          v-if="
            helenCard ||
            bcaCard ||
            lucidworksCard ||
            concordProjectsCard ||
            on3Card ||
            threeSixtyXCard
          "
          class="d-flex"
          :class="{
            'justify-end': rightAlignedLogo,
            'justify-space-between': !rightAlignedLogo,
          }"
        >
          <v-img
            v-if="helenCard"
            src="@/assets/Logo/helen.jpg"
            max-height="80"
            max-width="52"
            contain
            class="mb-1"
          />
          <v-img v-else-if="bcaCard" src="@/assets/Logo/bca.png" max-width="115" class="mb-2" />
          <v-img
            v-else-if="lucidworksCard"
            src="@/assets/Logo/lucidworks.png"
            max-width="195"
            contain
            class="mb-0"
          />
          <v-img
            v-else-if="concordProjectsCard"
            src="@/assets/Logo/concord-projects.png"
            max-width="135"
            contain
            class="mb-1"
          />
          <v-img
            v-else-if="threeSixtyXCard"
            src="@/assets/Logo/360x.png"
            max-width="125"
            contain
            class="mb-1"
          />

          <div class="d-flex flex-column align-end mr-3">
            <p class="customer-service-text mb-1 text-right">
              Customer service {{ customerServiceUrl }}
            </p>
            <v-img
              v-if="on3Card"
              src="@/assets/Logo/on3.png"
              max-width="135"
              contain
              class="mb-1"
            />
            <p class="virtual-card-text"><b>Virtual Card</b></p>
          </div>
        </div>
        <div v-else>
          <p
            class="customer-service-text mb-1"
            :class="{
              'text-right mr-3':
                prolinkCard ||
                skinCliqueCard ||
                shannonCard ||
                lucidworksCard ||
                tririnseCard ||
                on3Card ||
                rollingStrongCard,
            }"
          >
            Customer service
            {{ customerServiceUrl }}
          </p>
          <div class="d-flex justify-space-between align-center mb-3">
            <v-img v-if="kennelwoodCard" src="@/assets/Logo/kennelwood.png" max-width="135" />
            <v-img
              v-else-if="prolinkCard"
              src="@/assets/Logo/prolink-blue.png"
              max-width="175"
              height="50"
              contain
              class="mb-2"
            />
            <v-img
              v-else-if="skinCliqueCard"
              src="@/assets/Logo/skin-clique.png"
              max-width="165"
              contain
              class="mb-0"
            />
            <v-img
              v-else-if="shannonCard"
              src="@/assets/Logo/shannon.png"
              max-width="155"
              contain
              class="mb-0"
            />
            <v-img
              v-else-if="lucidworksCard"
              src="@/assets/Logo/lucidworks.png"
              max-width="145"
              contain
              class="mb-0"
            />
            <v-img
              v-else-if="tririnseCard"
              src="@/assets/Logo/tririnse.png"
              max-width="145"
              contain
              class="mb-0 mt-n4"
            />
            <v-img
              v-else-if="rollingStrongCard"
              src="@/assets/Logo/rolling-strong.png"
              max-width="220"
              contain
              class="mb-1"
            />
            <v-img
              v-else-if="!rightAlignedLogo"
              src="@/assets/Logo/whistle-logo-gradient-clean-v2.png"
              max-width="125"
            />
            <p class="virtual-card-text mr-3"><b>Virtual Card</b></p>
          </div>
        </div>
        <p class="label-text mb-0"><b>CARDHOLDER NAME</b></p>
        <p class="card-text mb-1">
          <b>{{ name ? name : "Cardholder Name" }}</b>
        </p>
        <p class="label-text mb-0"><b>ACCOUNT NUMBER</b></p>
        <div class="pci-box d-flex">
          <div id="mq-card-pan" class="card-pan"></div>
          <div id="copy-pan-container" style="position: relative">
            <v-icon alt="Copy card number" :color="darkCardVariant ? 'white' : undefined"
              >mdi-content-copy</v-icon
            >
          </div>
        </div>
        <div class="d-flex">
          <div class="d-flex flex-column">
            <p class="label-text mb-0"><b>CVV2</b></p>
            <div class="pci-box-small d-flex">
              <div id="mq-card-cvv" class="card-cvv"></div>
              <div id="copy-cvv-container" style="position: relative">
                <v-icon alt="Copy CVV2" :color="darkCardVariant ? 'white' : undefined"
                  >mdi-content-copy</v-icon
                >
              </div>
            </div>
          </div>
          <div class="d-flex flex-column ml-4">
            <p class="label-text mb-0"><b>Valid Thru</b></p>
            <div class="pci-box-small d-flex">
              <div id="mq-card-exp" class="card-exp"></div>
              <div id="copy-exp-container" style="position: relative">
                <v-icon alt="Copy expiration date" :color="darkCardVariant ? 'white' : undefined"
                  >mdi-content-copy</v-icon
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-space-between full-width px-1"
        :class="{
          'brand--text': !darkCardVariant,
          'white--text': darkCardVariant,
        }"
      >
        <div class="d-flex flex-column justify-space-between full-width">
          <p class="label-text mb-1 ml-4"><b>LIMITED USE</b></p>
          <p class="fdic-text mb-1 mt-1 word-break">
            <b>{{ issuerStatement }}</b>
          </p>
        </div>
        <div class="d-flex flex-column align-end">
          <p class="virtual-card-text mr-2 mb-1"><b>DEBIT</b></p>
          <v-img
            v-if="darkCardVariant"
            src="@/assets/Wallet/visa_white.png"
            max-width="105"
            contain
          />
          <v-img
            v-else-if="blueVisaLogo"
            src="@/assets/Wallet/visa_blue.png"
            max-width="105"
            contain
          />
          <v-img v-else src="@/assets/Wallet/visa.png" max-width="105" contain />
        </div>
      </div>
    </v-card>
    <body></body>
  </div>
</template>

<script>
import MarqetaService from "@/services/MarqetaService";
import Robin from "@/components/Robin";
import Alert from "@/components/generic/Alert.vue";
import whitelabelMixin from "@/mixins/whitelabelMixin";
import postscribe from "postscribe";
import VueJwtDecode from "vue-jwt-decode";
import moment from "moment";
import { mapState } from "vuex";

const LOAD_FAILED_MESSAGE =
  "We couldn't load your virtual card. Please try again later or contact support if the problem persists.";

export default {
  name: "MarqetaDisplayCardLegacy",
  props: {
    token: String,
    cardOnly: Boolean,
    elevation: {
      type: Boolean,
      default: true,
    },
    magicLink: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Robin,
    Alert,
  },
  mixins: [whitelabelMixin],
  data() {
    return {
      loading: false,
      loadFailed: false,
      loadFailedMessage: LOAD_FAILED_MESSAGE,
      name: null,
      displaySmallVersion: false,
    };
  },
  created() {
    this.displaySmallVersion = !!(window.innerWidth < 1200);
    this.getWidgetData();
    this.getMarqetaUser();
  },
  mounted() {
    if (process.env.VUE_APP_ENVIRONMENT == "dev" || process.env.VUE_APP_ENVIRONMENT == "test") {
      var marqetaUrl = "https://widgets-sandbox.marqeta.com/marqetajs/1.1.0/marqeta.min.js";
    } else {
      marqetaUrl = "https://widgets.marqeta.com/marqetajs/1.1.0/marqeta.min.js";
    }
    postscribe(
      "#marqeta-script",
      `<script src="${marqetaUrl}" type="text/javascript"><\/script>` //eslint-disable-line
    );
  },
  beforeUnmount() {
    this.isDestroyed = true;
  },
  methods: {
    getWidgetData() {
      var startTime = new Date();
      this.loading = true;
      const cardFontSize = this.displaySmallVersion ? "18px" : "1.4em";
      MarqetaService.getVirtualCardWidget(
        this.token,
        this.magicLink ? this.token : null,
        this.magicLinkToken
      )
        .then((x) => {
          if (this.isDestroyed) return;
          if (!x || !x.client_access_token) {
            console.log("Virtual card widget response had no client access token");
            this.failWidgetLoad();
            return;
          }
          const textColor = this.darkCardVariant ? "white" : "#1E2549";
          postscribe(
            "#marqeta-bootstrap-script",
            `<script>if (document.getElementById("mq-card-pan")) marqeta.bootstrap({
            "clientAccessToken": "${x.client_access_token}",
            "showPan": {
              "cardPan": {
                "domId": "mq-card-pan",
                "format": true,
                "styles": { span: {"font-family": "Avenir", "font-size": "${cardFontSize}", "color": "${textColor}", "font-weight": "500", "white-space": "nowrap"} }  // A custom styles object
              },
              "copyCardPan": {
                "domId": "copy-pan-container",
                "mode": "transparent",
                "onCopySuccess": () => { console.log("Copied PAN!"); },
                "onCopyFailure": error => {
                  console.error(error);
                }
              },
              "cardExp": {
                "domId": "mq-card-exp",
                "format": true,
                "styles": { span: {"font-family": "Avenir", "font-size": "${cardFontSize}", "color": "${textColor}", "font-weight": "500"} }
              },
              "copyCardExp": {
                "domId": "copy-exp-container",
                "mode": "transparent",
                "onCopySuccess": () => { console.log("Copied expiration date!"); },
                "onCopyFailure": error => {
                  console.error(error);
                }
              },
              "cardCvv": {
                "domId": "mq-card-cvv",
                "styles": { span: {"font-family": "Avenir", "font-size": "${cardFontSize}", "color": "${textColor}", "font-weight": "500"} }
              },
              "copyCardCvv": {
                "domId": "copy-cvv-container",
                "mode": "transparent",
                "onCopySuccess": () => { console.log("Copied CVV2!"); },
                "onCopyFailure": error => {
                  console.error(error);
                }
              }
            },
            "callbackEvents": {
              "onSuccess": () => { console.log("Success!")
              },
              "onFailure": error => { console.error(error);
              }
            }
          }
          );<\/script>` //eslint-disable-line
          );

          var timeDiff = moment().diff(moment(startTime));
          if (timeDiff < 2000) {
            setTimeout(() => {
              this.loading = false;
            }, 2000 - timeDiff);
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log("There was an error getting the virtual card widget: ", error);
          if (this.isDestroyed) return;
          this.failWidgetLoad();
        });
    },
    failWidgetLoad() {
      this.loadFailed = true;
      this.loading = false;
    },
    getMarqetaUser() {
      console.log("Getting user info");
      MarqetaService.getUser(this.token, this.magicLink ? this.token : null, this.magicLinkToken)
        .then((user) => {
          console.log("User response: ", user);
          this.name = (user.first_name + " " + user.last_name).toUpperCase();
        })
        .catch((error) => {
          console.log("There was an error getting user: ", error);
          // this.currentSlide++;
        });
    },
    resetForm() {
      this.$emit("scrollToTop");
      this.$emit("reset");
      this.$emit("get-cards", "marqetaDisplayCard");
    },
    previousSlide() {
      this.$emit("scrollToTop");
      this.resetForm();
    },
    compareClientId(clientId) {
      if (!this.userProfile) return false;
      try {
        if (this.token) {
          let decoded = VueJwtDecode.decode(this.token);
          const metadata = decoded["https://whistle.com/metadata"];
          if (metadata && metadata.clientId == clientId) return true;
        }
      } catch (e) {
        console.log("Error decoding token ", e);
      }
      return this.userProfile.clientId == clientId;
    },
  },
  computed: {
    ...mapState(["userProfile", "magicLinkToken"]),
    darkCardVariant() {
      return this.skinCliqueCard || this.on3Card;
    },
    rightAlignedLogo() {
      return this.on3Card;
    },
    blueVisaLogo() {
      return this.threeSixtyXCard || this.rollingStrongCard;
    },
    issuerStatement() {
      switch (true) {
        case this.on3Card:
          return "The On3 Card by Whistle is issued by Sutton Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc.";
        case this.threeSixtyXCard:
          return "The 360x Staffing by Whistle Card is issued by Sutton Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc.";
        case this.rollingStrongCard:
          return `The Whistle Card by Rolling Strong is issued by Sutton Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc.${this.cardholderSupportClause}`;
        default:
          return "This card is issued by Sutton Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc. The Whistle card is powered by Marqeta.";
      }
    },
    // Card art cannot host CustomerServiceContact, so the sentence is built
    // from the same sources that component uses: tenant supportEmail and the
    // platform support phone. Literals here fail the support-contact guard.
    cardholderSupportClause() {
      const phone = process.env.VUE_APP_SUPPORT_PHONE;
      const email = this.supportEmail;
      if (phone && email) return ` For card holder support call ${phone} or email ${email}`;
      if (phone) return ` For card holder support call ${phone}`;
      if (email) return ` For card holder support email ${email}`;
      return "";
    },
    customerServiceUrl() {
      return this.kennelwoodCard ? "kennelwood.com/rewards" : "www.wewhistle.com/card-support";
    },
    helenCard() {
      const clientId = 375;
      return this.compareClientId(clientId);
    },
    kennelwoodCard() {
      const clientId = 516;
      return this.compareClientId(clientId);
    },
    bcaCard() {
      const clientId = 495;
      return this.compareClientId(clientId);
    },
    prolinkCard() {
      const clientId = 533;
      return this.compareClientId(clientId);
    },
    skinCliqueCard() {
      const clientId = 513;
      return this.compareClientId(clientId);
    },
    shannonCard() {
      const clientId = 557;
      return this.compareClientId(clientId);
    },
    lucidworksCard() {
      const clientId = 365;
      return this.compareClientId(clientId);
    },
    concordProjectsCard() {
      const clientId = 582;
      return this.compareClientId(clientId);
    },
    tririnseCard() {
      const clientId = 564;
      return this.compareClientId(clientId);
    },
    on3Card() {
      const clientId = 663;
      return this.compareClientId(clientId);
    },
    threeSixtyXCard() {
      const clientId = 640;
      return this.compareClientId(clientId);
    },
    rollingStrongCard() {
      const clientId = 541;
      return this.compareClientId(clientId);
    },
  },
  watch: {},
};
</script>

<style scoped id="styles">
.virtual-card {
  max-width: 485px;
  min-width: 0;
}

.virtual-card--on3 {
  background-color: #000 !important;
  background-image: url("~@/assets/Logo/on3-background.png");
  background-repeat: no-repeat;
  background-position: left center;
  /* Full card height; width follows image aspect ratio (does not stretch full width) */
  background-size: auto 100%;
}

.virtual-card.shrink {
  height: 1px;
}
/* Code for transitions between slides */

.topic-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.topic-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.topic-left-enter-active,
.topic-right-enter-active {
  transition: all 0.65s cubic-bezier(0.19, 1, 0.22, 1);
}

#copy-pan-container:hover > .v-icon {
  opacity: 0.5;
  cursor: pointer;
}

#copy-exp-container:hover > .v-icon {
  opacity: 0.5;
  cursor: pointer;
}

#copy-cvv-container:hover > .v-icon {
  opacity: 0.5;
  cursor: pointer;
}

.pci-box {
  height: 35px;
}
.pci-box-small {
  height: 25px;
}

.card-pan {
  width: 235px;
  min-width: 235px;
}
.pci-box >>> iframe,
.pci-box-small >>> iframe {
  max-width: 100%;
}
.card-exp {
  width: 75px;
}
.card-cvv {
  width: 55px;
}

.card-text {
  font-size: 1.35em;
}

.virtual-card-text {
  font-size: 1.3em;
}
.customer-service-text {
  font-size: 12px;
  font-weight: 600;
}
.label-text {
  font-size: 12px;
}
.fdic-text {
  font-size: 10px;
  line-height: 120%;
}

.card-border {
  border: solid 1px !important;
  border-color: lightgray !important;
  /* border-radius: 0; */
}

@media (max-width: 1200px) {
  .card-text {
    font-size: 18px;
  }
  .virtual-card-text {
    font-size: 16px;
  }
  .card-pan {
    width: 200px;
    min-width: 192px;
  }
  .card-exp {
    width: 65px;
  }
  .card-cvv {
    width: 45px;
  }
}
</style>
